import { API_BASE_URL } from "../../../../../../common/utils/commonUrl";
import http from "../../../../../../common/utils/http";
import dateUtil from "../../../../../../common/utils/dateUtil";
import FormatTableFieldUtils from "../../../../../../common/utils/format-table-field-util";
import * as DataTypeConstants from "../../../../../../constants/DataTypeConstants";
import * as DictionaryConstants from "../../../../../../constants/DictionaryConstants";

export default {
  data () {
    return {
      activeName: '1000',
      id: '',
      carMaintenances: [],
      basicInfo: {},
      insuranceInfo: {},
      vehicleName: ''
    }
  },
  methods: {
    handleClick (val) {
      // console.log(val, 'dddddddd')
    },
    // 会员车辆维修信息
    async getCarMaintenance () {
      const carMaintenances = (await http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getCarMaintenance?carId=' + this.id)).data.data

      await FormatTableFieldUtils.formatTableFieldName(carMaintenances, [
        {
          fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
          fieldPropCode: 'maintenanceCategory',
          fieldPropName: 'maintenanceCategoryName',
          fieldFormatParam: DictionaryConstants.CSM_MAINTAIN_CATEGORY
        }
      ])
      console.log(carMaintenances, 'carMaintenancescarMaintenancescarMaintenances')
      this.carMaintenances = carMaintenances
    },
    // 会员车辆保险信息
    async getInsuranceInfo () {
      const insuranceInfo = (await http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getInsuranceInfo?carId=' + this.id)).data.data

      await FormatTableFieldUtils.formatTableFieldName([insuranceInfo], [
        {
          fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
          fieldPropCode: 'insuranceCompany',
          fieldPropName: 'insuranceCompanyName',
          fieldFormatParam: DictionaryConstants.IIM_INSURANCE_COMPANY
        }
      ])

      this.insuranceInfo = insuranceInfo
    },
    // 会员车辆基础信息
    async getBasicInfo () {
      this.basicInfo = (await http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getBasicInfo?carId=' + this.id)).data.data
    }
  },

  mounted () {
    this.id = this.$route.query.id
    this.vehicleName = this.$route.query.vehicleName
    this.getCarMaintenance()
    this.getInsuranceInfo()
    this.getBasicInfo()
  }
};



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-service/views/my-car-serve/my-car-serve.js